<template>
  <div class="charts-container">
    <div class="chart-pie"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ChartsPie',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colors: ['#259fff', '#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff'],
      chartName: '算力芯片分布',
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.update();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$el.querySelector('.chart-pie'));
      window.addEventListener('resize', () => this.chart.resize());
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', () => this.chart.resize());
        this.chart.dispose();
      });
      this.update();
    },
    update() {
      if (!this.chart) return;

      const { innerRing, outerRing, legendData } = this.data;

      const option = {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          right: 25, // 将图例放在图表的右侧
          top: '70', // 使用'auto'让ECharts自动计算位置
          bottom: 10, // 调整此值将图例放置在距离底部20像素的位置
          itemGap: 20,
          itemHeight: 20, // 减小图例项的高度
          itemWidth: 10, // 减小图例项的宽度
          icon: 'circle', // 使用圆形图标
          textStyle: {
            color: '#fff', // 设置图例文字颜色
            fontSize: 12,
            fontFamily: '"OPPOSans R",sans-serif',
          },
          data: legendData,
        },
        series: [
          {
            name: '内环',
            type: 'pie',
            radius: ['0%', '50%'], // 内环设置为几乎重合的两个半径值以形成实心圆
            center: ['20%', '50%'], // 确保内环位于中心
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: innerRing.map((item, index) => ({
              name: item.name,
              value: item.value,
              itemStyle: { color: this.colors[index % this.colors.length] }
            })),
          },
          {
            name: '外环',
            type: 'pie',
            radius: ['60%', '70%'], // 外环的半径范围
            center: ['20%', '50%'], // 确保外环位于中心
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: outerRing.map((item, index) => ({
              name: item.name,
              value: item.value,
              itemStyle: { color: this.colors[index % this.colors.length] }
            })),
          }
        ],
        graphic: [{
          type: 'text',
          left: '40',
          bottom: 0, // 调整此值以确定文本与图表之间的距离
          style: {
            text: this.chartName,
            textAlign: 'center',
            fill: '#f5f5f5', // 文字颜色
            fontSize: 12,
            fontFamily: '"OPPOSans R",sans-serif',
          },
        }]
      };

      this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.charts-container {
  display: flex;
  justify-content: center;
}

.chart-pie {
  margin-top: 20px;
  width: 100%; /* 根据需要调整宽度 */
  height: 158px; /* 根据需要调整高度 */
}
</style>